  /**
 * Unit type information
 */
export type UnitType = {
  coalition: Coalition;
  country: string;
  formation: string;
};

export enum Coalition { 
  NATO = 'ECoalition/NATO',
  PACT = 'ECoalition/PACT',
}
/**
 * Speed on specific terrain
 */
export type SpeedOnTerrain = {
  name: string;
  speed: number;
};

/**
 * Info panel type enum values
 */
export enum InfoPanelType {
  DEFAULT = 'default',
  SUPPLY_VEHICLE = 'supply-vehicle',
  TRANSPORT_VEHICLE = 'transport-vehicle',
  INFANTRY = 'infantry',
  PLANE = 'plane',
  HELICOPTER = 'helicopter',
  TRANSPORT_HELICOPTER = 'transport-helicopter',
  SUPPLY_HELICOPTER = 'supply-helicopter',
  FOB = 'fob',
}

/**
 * Movement type enum values
 */
export enum MovementType {
  LAND = 'land',
  HELICOPTER = 'helicopter',
  PLANE = 'plane',
}

/**
 * Unit data structure as it appears in JSON output
 */
export type Unit = {
  id: number | undefined;
  name: string;
  descriptorName: string;
  weaponDescriptorName: string | undefined;
  commandPoints: number;
  unitType: UnitType;
  infoPanelType: InfoPanelType;
  factoryDescriptor: string;
  frontArmor: number;
  sideArmor: number;
  rearArmor: number;
  topArmor: number;
  frontArmorType: string;
  sideArmorType: string;
  rearArmorType: string;
  topArmorType: string;
  era: boolean;
  maxDamage: number;
  speed: number;
  roadSpeed: number;
  rotationTime: number;
  unitMovingType?: string;
  movementType: MovementType;
  occupiableTerrains: string[];
  optics: number;
  airOptics: number;
  lowAltOptics: number | undefined;
  opticsRange: number | undefined;
  airOpticsRange: number | undefined;
  lowAltOpticsRange: number | undefined;
  bombStrategy: string | undefined;
  stealth: number;
  ecm: number;
  fuel: number;
  fuelMove: number;
  supply: number;
  advancedDeployment: number;
  agility: number | undefined;
  flyingAltitude: number | undefined;
  travelTime: number | null;
  specialities: string[];
  isCommand: boolean | undefined;
  isSpecialForces: boolean;
  xpBonuses: string;
  isSellable: boolean;
  dangerousness: number | undefined;
  divisions?: string[];
};

